module.exports = __webpack_public_path__ + "img/ba.74db8899.svg";